import { api } from 'api/client';
import { Position } from 'types/position';

export const fetchPositions = () => api.get<Position[]>('/position');
